// Lo que el agente necesita de Pau antes de contratar (diseño §2.2, §10.2). Reglas puras; el
// entrenador del encargo (servidor) las afina, pero estas bastan para no dejar contratar a medias.
// S10: el puesto y el tipo de trabajo ya no son de Pau: los elige el agente en su plan.
import { detectarTecnicismos } from '../compartido/lenguaje';

export { pareceSecreto } from '../compartido/lenguaje';

export interface BorradorContratar {
  caja: string;
  salaId: string;
  modelo: string;
  potencia: 'low' | 'medium' | 'high' | 'xhigh' | 'max';
  resultado: string;
  paraQue: string;
  comoSabre: string;
  noLoSe: boolean;
  noTocar: string;
  nombre: string;
  tema: string;
}

export interface EstadoNecesidades {
  resultado: boolean;
  paraQue: boolean;
  comoSabre: boolean;
  puedeContratar: boolean;
  /** Si Pau menciona material que no ha pegado («lo que me ha mandado Santi»). */
  faltaMaterial: boolean;
}

const MENCIONA_MATERIAL = /\b(esto|lo que (?:me )?(?:ha|han) (?:mandado|enviado|pasado)|te (?:adjunto|paso|envío)|mira (?:esto|el ticket))\b/i;

export function necesidades(b: BorradorContratar): EstadoNecesidades {
  const caja = b.caja.trim();
  const resultado = b.resultado.trim().length >= 8 || caja.length >= 40;
  const paraQue = b.paraQue.trim().length >= 5;
  const comoSabre = b.noLoSe || b.comoSabre.trim().length >= 5;
  const faltaMaterial = MENCIONA_MATERIAL.test(caja) && caja.length < 160 && !/https?:\/\//.test(caja);
  // S11: basta con el encargo; el contexto ayuda y, si falta, el agente lo pregunta en su plan.
  return { resultado, paraQue, comoSabre, faltaMaterial, puedeContratar: caja.length >= 5 && !!b.salaId };
}

export function aFormulario(b: BorradorContratar) {
  return {
    caja: b.caja.trim(),
    salaId: b.salaId,
    modelo: b.modelo,
    potencia: b.potencia,
    // Sin nombre: Pau no pone nombres a los agentes (28-09); el backend le pone uno interno.
    ...(b.tema.trim() ? { tema: b.tema.trim() } : {}),
    respuestas: {
      ...(b.resultado.trim() ? { resultado: b.resultado.trim() } : {}),
      ...(b.paraQue.trim() ? { paraQue: b.paraQue.trim() } : {}),
      ...(b.noLoSe ? { comoSabre: 'no_lo_se' } : b.comoSabre.trim() ? { comoSabre: b.comoSabre.trim() } : {}),
    },
    ...(b.noTocar.trim() ? { noTocar: b.noTocar.trim() } : {}),
  };
}

export { detectarTecnicismos };
